import { PromoCodeApplicationEnum } from '../../lib/types/enums/promo-code/promo-code-application.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type GetEnrollmentPropositionPromoCodeApplicationInput = {
  enrollmentId: number
  propositionId: number
}

export function getEnrollmentPropositionPromoCodeApplication(
  input: GetEnrollmentPropositionPromoCodeApplicationInput
) {
  const { enrollmentId, propositionId } = input
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentPropositionPromoCodeApplication.url, {
        id: enrollmentId,
        propositionId
      })
    )
    .get<PromoCodeApplicationEnum | null>()
}
